import {computed, inject, Inject, Injectable} from '@angular/core';
import {catchError, exhaustMap, map, Observable, tap} from 'rxjs';
import {AUTH_CONFIG} from 'src/app/config/auth.config';
import {JWT_CONFIG} from 'src/app/config/jwt.config';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {decodeJwt} from 'src/app/shared/functions/encode-decode.functions';
import {ApiService} from './api.service';
import {CookieService} from './cookie.service';
import {AuthResponse} from '../models/auth.model';
import {IJWTDecoded, JWTschema, JWTState} from '../models/jwt.model';
import {createEffect} from 'src/app/shared/functions/create-effect.functions';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { ApiSentrynelService } from './api-sentrynel.service';
import {toObservable} from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  readonly token = this.jwtStore.selectKey('token');
  readonly decodedToken = this.jwtStore.selectKey('decodedToken');
  readonly refreshInterval = this.jwtStore.selectKey('refreshInterval');
  readonly isValidToken = computed(() => (this.decodedToken().exp > this.decodedToken().iat) && (this.decodedToken().exp > (Math.floor(Date.now() / 1000))));

  private refreshTokenInterval = computed(() => (((this.decodedToken()?.exp - this.decodedToken().iat) * 1000) - (AUTH_CONFIG.refreshTokenSecondsAhead * 1000)))

  constructor(
    @Inject('jwt-store') private readonly jwtStore = inject(SignalStore<JWTState>),
    private cookieService: CookieService,
    private apiService: ApiService,
    private apiSentrynelService: ApiSentrynelService,
    private keycloakService:KeycloakService
  ) {}

  /** Inizializza lo stato del token a partire dai cookie. Da chiamare all'avvio dell'app. */
  public init(): void {
    if (this.cookieService.check(JWT_CONFIG.jwtCookieName)) {
      void this.set(this.cookieService.get(JWT_CONFIG.jwtCookieName));
    }
    if (this.cookieService.check(JWT_CONFIG.refreshToken)) {
      void this.setRefreshToken(this.cookieService.get(JWT_CONFIG.refreshToken));
    }
    if (this.cookieService.check(JWT_CONFIG.IdTokenHint)) {
      void this.setIdTokenHint(this.cookieService.get(JWT_CONFIG.IdTokenHint));
    }
  }  public refreshSession(): Observable<any> {
    return this.apiService.post<any>("auth/refreshToken", {
      refreshToken: this.jwtStore.selectKey('refreshToken')(),
      client_id: environment.keycloak.clientId
    }).pipe(
      tap((data) => {
        if (data && data.access_token) {
          this.set(data.access_token);
          if (data.id_token) this.setIdTokenHint(data.id_token);
          if (data.refresh_token) this.setRefreshToken(data.refresh_token);
        }
      }),
      map(data => data.access_token)
    );
  }

  public getNewToken(): Observable<string> {
    return toObservable(this.jwtStore.selectKey('token'))
  }

  public async set(jwtToken: string) {
    //const token = await this.keycloakService.getToken()
    this.jwtStore.setKey<'token'>('token', jwtToken);
     let decodedToken = decodeJwt<IJWTDecoded>(jwtToken, JWTschema)
      this.jwtStore.setKey('decodedToken', decodedToken);
      if (this.isValidToken()) {

        //this.apiService.setHeader('Authorization', `Bearer ${jwtToken}`);
        //this.apiSentrynelService.setHeader('Authorization', `Bearer ${jwtToken}`);

        this.cookieService.set(JWT_CONFIG.jwtCookieName, jwtToken);

        clearInterval(this.refreshInterval());
      } else {
        this.unset();
      }

  }


  public getTokenJwt(){
    return this.jwtStore.selectKey("token")()
  }

  public async setRefreshToken(refreshToken: string){
    this.jwtStore.setKey<'refreshToken'>('refreshToken', refreshToken);
    this.cookieService.set(JWT_CONFIG.refreshToken, refreshToken);
  }
  async setIdTokenHint(IdTokenHint: string) {
    this.jwtStore.setKey<'IdTokenHint'>('IdTokenHint', IdTokenHint);
    this.cookieService.set(JWT_CONFIG.IdTokenHint, IdTokenHint);
  }
   getIdTokenHint(): string {
    return this.jwtStore.selectKey("IdTokenHint")();
  }

  public unset() {
    this.jwtStore.setKey('decodedToken', {
      iat: 0,
      exp: 0,
      userId: null
    });
    this.jwtStore.setKey<'token'>('token', '');
    this.jwtStore.setKey<'refreshToken'>('refreshToken', '');
    this.cookieService.delete(JWT_CONFIG.jwtCookieName);
    this.cookieService.delete(JWT_CONFIG.refreshToken);
        this.cookieService.delete(JWT_CONFIG.IdTokenHint);
    this.apiService.setHeader('Authorization', undefined);
    if (this.refreshInterval()) {
      clearInterval(this.refreshInterval());
    }
   // this.keycloakService.logout(environment.keycloak.redirectUrl)
  }

}
